import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { getServiceIdSelector } from '../../user/selectors'
import { DrainService } from '../../procedures/drain/services/drain.service'
import * as actions from '../store/options.actions'

export function* setDrainFoleyColorOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const drainService = new DrainService(serviceId)
  try {
    const response: IOptionsResponse = yield call([drainService, drainService.getFoleyColorOptions])
    const { entity } = response
    yield put(actions.setDrainFoleyColorOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setDrainFoleyColorOptions() error: ${e}`))
  }
}
export function* setDrainFoleyColorOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setDrainFoleyColorOptions)
}
